import React from 'react';
import { Button, ModalHeader, ModalBody, ModalFooter, Typography, } from '@one-thd/sui-atomic-components';
import { PHAlogo } from '../images/PHAlogo';
import { CardInfo } from '../card/card-info';
export const PhaUnenrollT2cConfirmModal = ({ onRejected, onConfirm, card, cardType, bodyText, headerText, }) => {
    return (React.createElement("div", null,
        React.createElement(ModalHeader, { onClose: () => onRejected() }, headerText),
        React.createElement(ModalBody, null,
            cardType === 'proHouseAccount' && (React.createElement("div", { className: "sui-flex sui-flex-wrap sui-mb-4" },
                React.createElement(PHAlogo, null),
                React.createElement("div", { className: "sui-ml-4" },
                    React.createElement(Typography, { variant: "body-lg", color: "subtle" },
                        "****",
                        card.cardNumberLast4)))),
            cardType === 'creditCards' && (React.createElement("div", { className: "sui-my-6" },
                React.createElement(CardInfo, { card: card }))),
            React.createElement(Typography, { variant: "body-base" }, bodyText)),
        React.createElement(ModalFooter, { position: "end" },
            React.createElement("div", { className: "sui-flex sui-gap-4 sm:sui-gap-4 sui-flex-col-reverse sui-w-full sm:sui-flex-row sm:sui-w-auto" },
                React.createElement(Button, { variant: "secondary", onClick: () => onRejected() }, "No"),
                React.createElement(Button, { variant: "primary", type: "submit", "data-testid": "submitBtn", onClick: () => onConfirm() }, "Yes, Stop Text2Confirm")))));
};
